import $ from '../vendor/jquery';
import slidebars from '../vendor/slidebars';

// slidebars
$(function () {
  var controller = new slidebars();
  controller.init();

  $('.overlay').click(function () {
    controller.close('off-canvas');
  });

  $(controller.events).on('closing', function () {
    $('.overlay').fadeOut();
    $('.off-canvas-trigger').removeClass('open');
    $('.page-header-compact').removeClass('open');
  });

  $(controller.events).on('opening', function () {
    $('.overlay').fadeIn();
  });

  $('.off-canvas-trigger').on('click', function (event) {
    event.preventDefault();
    if ($('.off-canvas-trigger').hasClass('open')) {
      controller.close('off-canvas');
      $(this).removeClass('open');
    } else {
      controller.open('off-canvas');
      $('.page-header-compact').addClass('open');
      $(this).addClass('open');
    }
  });
});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/slidebars.js